import React from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { styled } from 'styled-components';
import { colorsTheme } from 'resources/theme/styled/colors';

// components
import HelpAndWithdrawSection from '../HelpAndWithdrawSection';
import { Col, Divider, Row, SectionIntro, Text } from '@ui';
import { Trans } from 'react-i18next';

const UnderReview = () => {
  const { t } = useTranslation('onboarding');

  return (
    <>
      <SectionIntro
        hideDivider
        titleColor={colorsTheme.colorWhite}
        title={t('intake_form.under_review.title')}
      />
      <StyledRow justify="space-between">
        <Col span={24}>
          <TextWithTopMargin>
            {t('intake_form.under_review.description_line_1')}
          </TextWithTopMargin>
          <TextWithTopMargin color={colorsTheme.colorWhite}>
            {t('intake_form.under_review.description_line_2')}
          </TextWithTopMargin>
        </Col>
        <Col span={24}>
          <Divider />
          <HelpAndWithdrawSection
            helpTitle={t('intake_form.under_review.need_help_title')}
            helpDescription={
              <Trans
                t={t}
                i18nKey="intake_form.under_review.need_help_description"
                components={[
                  <Text
                    weight="semi-bold"
                    variant="span"
                    color={colorsTheme.colorWhite}
                  />,
                ]}
              />
            }
          />
        </Col>
      </StyledRow>
    </>
  );
};

const TextWithTopMargin = styled(Text)`
  margin-top: ${({ theme }) => theme.marginMd};
`;

const StyledRow = styled(Row)`
  height: 100%;
`;

export default UnderReview;
